import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import Logo from '../images/aknow-logo.png';
import Auth from '../store/auth';
import { Header } from 'semantic-ui-react';

// The Header creates links that can be used to navigate
// between routes.
const AppHeader = () => (
	<header className="App-header">
		<nav>
			<NavLink exact={true} activeClassName="active" to='/'>
				<i className="fa fa-th-large" aria-hidden="true"></i>Dashboard
			</NavLink>

			<NavLink activeClassName="active" to='/uploaddata'>
				<i className="fa fa-linode" aria-hidden="true"></i>Upload Document
			</NavLink>

			<NavLink activeClassName="active" to='/downloaddata'>
				<i className="fa fa-superpowers" aria-hidden="true"></i>Document List
			</NavLink>

			<NavLink activeClassName="active" to='/shareddoc'>
				<i className="fa fa-handshake-o" aria-hidden="true"></i>Shared Document
			</NavLink>

			<NavLink activeClassName="active" to='/reviewdoc'>
				<i className="fa fa-grav" aria-hidden="true"></i>Review Document
			</NavLink>

			<NavLink activeClassName="active" to='/approvedoc'>
				<i className="fa fa-ravelry" aria-hidden="true"></i>Approve Document
			</NavLink>

			<NavLink activeClassName="active" to='/docgrp'>
				<i className="fa fa-bullseye" aria-hidden="true"></i>Document Group
			</NavLink>

			<NavLink activeClassName="active" to='/dochist'>
				<i className="fa fa-bandcamp" aria-hidden="true"></i>Document History
			</NavLink>

            <NavLink activeClassName="active" to='/sendemail'>
				<i className="fa fa-envelope-open-o" aria-hidden="true"></i>Send Email
			</NavLink>

            <NavLink activeClassName="active" to='/reports'>
				<i className="fa fa-bar-chart" aria-hidden="true"></i>Reports
			</NavLink>

            {Auth.getAdmin() === 'Y' && (
			<NavLink activeClassName="active" to='/org'>
				<i className="fa fa-grav" aria-hidden="true"></i>Admin-Org
			</NavLink>
			)}

	        {Auth.getAdmin() === 'Y' && (
			<NavLink activeClassName="active" to='/user'>
				<i className="fa fa-handshake-o" aria-hidden="true"></i>Admin-User
			</NavLink>
			)}

           {Auth.getAdmin() === 'Y' && (
			<NavLink activeClassName="active" to='/bcexpl'>
				<i className="fa fa-free-code-camp" aria-hidden="true"></i>BlockChain Explorer
			</NavLink>
		   )}


			{Auth.isUserAuthenticated() && <NavLink to='/logout'><i className="fa fa-sign-out" aria-hidden="true"></i>Logout</NavLink>}
			{!Auth.isUserAuthenticated() && <NavLink to='/login'><i className="fa fa-sign-in" aria-hidden="true"></i>Login</NavLink>}

		</nav>
	</header>
)

export default AppHeader
/*
            {Auth.getAdmin() === 'Y' && (
			<NavLink activeClassName="active" to='/downloaddata'>
				<i className="fa fa-superpowers" aria-hidden="true"></i>Document List
			</NavLink>
			)}

            {(Auth.getAdmin() === 'Y' || Auth.getShared() === 'Y') && (
			<NavLink activeClassName="active" to='/shareddoc'>
				<i className="fa fa-handshake-o" aria-hidden="true"></i>Shared Document
			</NavLink>
			)}

            {(Auth.getAdmin() === 'Y' || Auth.getReviewer() === 'Y') && (
			<NavLink activeClassName="active" to='/reviewdoc'>
				<i className="fa fa-grav" aria-hidden="true"></i>Review Document
			</NavLink>
			)}

            {(Auth.getAdmin() === 'Y' || Auth.getApprover() === 'Y') && (
			<NavLink activeClassName="active" to='/approvedoc'>
				<i className="fa fa-ravelry" aria-hidden="true"></i>Approve Document
			</NavLink>
			)}

			<NavLink activeClassName="active" to='/dochist'>
				<i className="fa fa-bandcamp" aria-hidden="true"></i>Document History
			</NavLink>

            <NavLink activeClassName="active" to='/sendemail'>
				<i className="fa fa-envelope-open-o" aria-hidden="true"></i>Send Email
			</NavLink>

            {Auth.getAdmin() === 'Y' && (
			<NavLink activeClassName="active" to='/org'>
				<i className="fa fa-grav" aria-hidden="true"></i>Admin-Org
			</NavLink>
			)}

	        {Auth.getAdmin() === 'Y' && (
			<NavLink activeClassName="active" to='/user'>
				<i className="fa fa-handshake-o" aria-hidden="true"></i>Admin-User
			</NavLink>
			)}

           {Auth.getAdmin() === 'Y' && (
			<NavLink activeClassName="active" to='/bcexpl'>
				<i className="fa fa-free-code-camp" aria-hidden="true"></i>BlockChain Explorer
			</NavLink>
		   )}

*/




// WEBPACK FOOTER //
// ./src/components/header.js